import { InlineText2 } from '@cian/ui-kit/typography';
import * as React from 'react';
import { LinkButton } from '../../../../../common/LinkButton';
import { ErrorWrapper } from '../ErrorWrapper';
import * as styles from './UnexpectedError.css';
const sadSmileIcon = require('../../../../../../assets/sad-smile.png');

interface IUnexpectedErrorProps {
  onReloadClick(): void;
}

export const UnexpectedError = ({ onReloadClick }: IUnexpectedErrorProps) => {
  return (
    <ErrorWrapper>
      <img src={sadSmileIcon} width={24} height={24} />

      <div className={styles['text']}>
        <InlineText2 textAlign="center">Что-то пошло не так</InlineText2>
      </div>

      <LinkButton marginTop={8} onClick={onReloadClick}>
        Попробовать снова
      </LinkButton>
    </ErrorWrapper>
  );
};
